import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 3rem 2rem 4rem;
`;

export const Title = styled.h1`
  padding: 0 0 1.5rem;
`;

export const FiltersWrapper = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
`;

export const SelectWrapper = styled.div`
  min-width: 115px;
  width: fit-content;
`;

export const DOC_CARD_TEMPLATE_COLUMNS = '65px 3fr 1.5fr 1fr 80px 46px';
export const SUPERVISOR_DOC_CARD_TEMPLATE_COLUMNS =
  '65px 3fr 1.5fr 1fr 80px 80px 46px';
export const INNER_DOC_CARD_TEMPLATE_COLUMNS = '65px 3fr 1.5fr 1fr 80px 130px';
export const Legend = styled.div`
  display: grid;
  grid-template-columns: ${DOC_CARD_TEMPLATE_COLUMNS};
  gap: 24px;
  padding-bottom: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.textSecondary};

  &.inner-documents {
    grid-template-columns: ${INNER_DOC_CARD_TEMPLATE_COLUMNS};
  }
`;

export const DocumentsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 3rem;

  @media ${(props) => props.theme.device.mobileL} {
    gap: 0;
  }
`;
